import { createRoot } from 'react-dom/client'
import App from './App'
import { captureReferralFromUrl } from './lib/referral'
import './index.css'

// 必须在渲染前跑：router 初始化时读取的就该是已清理掉 ref 的地址。
captureReferralFromUrl()

const container = document.getElementById('root')
if (!container) {
  throw new Error('root container not found')
}

createRoot(container).render(<App />)
